<div class="body" @show [formGroup]="formGroup">

    <div class="inner">

        <div class="login-form-wrapper stretch-small">

            <div class="headline">
                WISTA AMS
            </div>

            <div class="subtitle">
                Melden Sie sich mit ihrem Wista AMS Zugang an.
            </div>

            <mat-form-field class="form-field" appearance="fill" >
                <input
                    matInput 
                    (keydown.enter)=login() 
                    placeholder="Benutzername" 
                    formControlName="username"
                />
            </mat-form-field>

            <mat-form-field class="form-field" appearance="fill" >
                <input 
                    matInput 
                    (keydown.enter)=login()
                    placeholder="Passwort" 
                    type="password" 
                    formControlName="password"
                />
            </mat-form-field>

            <div class="customer-client-hint" (click)="navigateToCustomerClient()">

                <div class="text">
                    Sie sind Kunde? Dann wechseln Sie zum Kundenportal.
                </div>

                <div class="icon">
                    <mat-icon>arrow_right</mat-icon>
                </div>
                
            </div>

            <div class="customer-client-hint" (click)="startPasswordReset()">

                <div class="text">
                    Passwort vergessen?
                </div>

                <div class="icon">
                    <mat-icon>arrow_right</mat-icon>
                </div>
                
            </div>

            <div class="button-wrapper">
                
                <button mat-raised-button [disabled]="formGroup.invalid" color="primary" (click)="login()">Login</button>

            </div>

        </div>

        <div class="label-wrapper small-hidden">
            <div *ngIf="loginState == 0" class="error-message">Keine Verbindung zum Server</div>
            <div *ngIf="wrongCredentials" class="error-message">
                Falscher Benutzername oder falsches Passwort
            </div>
            <div *ngIf="lockedOut" class="error-message">Ihr Account wurde zur Sicherheit bis {{lockedOutEnd|date:"dd.MM.yyyy HH:mm:ss"}} gesperrt</div>
            <img style="width: 200px" src="./assets/ctlogo.png">
        </div>

    </div>

</div>